import { Input, InputProps } from "antd";
import { FormItem, FormItemProps } from "react-hook-form-antd";
import { FormType } from "../../types/form-type.ts";

interface IObjectFormInput extends Omit<FormItemProps<FormType>, "children"> {
  inputProps?: InputProps;
}

export function ObjectFormInput({ inputProps, ...rest }: IObjectFormInput) {
  return (
    <div className="form-section-label">
      <FormItem
        {...rest}
        style={{
          margin: 0,
          ...rest.style,
        }}
      >
        <Input
          {...inputProps}
          className="object-form-input"
          style={{
            height: "36px !important",
            lineHeight: "36px !important",
          }}
        />
      </FormItem>
    </div>
  );
}
